<template>
	<div class="most-popular-products-wrapper">
		<transition name='mv'>
			<ul v-if="list.length > 0">
				<li v-for="li in list">
					{{li}}
				</li>
			</ul>
		</transition>
	</div>
</template>
<script>
export default {
	props: {
		db: {
			type: Array,
			default () {
				return [];
			}
		}
	},
	data() {
		return {
			list: ['类型A','类型B的名称']
		}
	},
	mounted() {
		this.list = JSON.parse(JSON.stringify(this.$props.db));
	},
	watch: {
		db(val,oldVal) {
			if(JSON.stringify(val) != JSON.stringify(oldVal)) {
				this.list = []
				this.reloadData();
			}
		}
	},
	methods: {
		reloadData() {
			clearTimeout(this.popTimeout);
			this.popTimeout = setTimeout(() => {
				this.list = JSON.parse(JSON.stringify(this.$props.db));
				clearTimeout(this.popTimeout);
			}, 500);
		}
	}
}

</script>
<style scoped>
	ul,li {
		list-style: none;
		padding: 0;
		margin: 0;
		line-height: 43px;
	}
	li {
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1.5em;
		position: absolute;
		width: 120px;
		height: 120px;
		padding: 15px;
		border-radius: 50%;
		border: 2px solid #fff;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		overflow: hidden;
		vertical-align: middle;
		box-shadow: 0 20px 30px rgba(0,0,0,.2);
	}
	ul li:nth-child(1) {
		left: 150px;
		top: 54px;
		background: linear-gradient(rgba(32,160,255,.6),rgba(32,160,255,0));
		border-color: rgba(32,160,255,.8);
		transform: scale(1);
		animation: up-down 2.1s infinite ease -0.5s;
	}
	ul li:nth-child(2) {
		left: 0px;
		top: 0px;
		background: linear-gradient(rgba(255,198,0,.6),rgba(255,198,0,0));
		border-color: rgba(255,198,0,.8);
		transform: scale(.8);
		animation: up-down 2s infinite ease -0.2s;
	}
	ul li:nth-child(4) {
		left: 30px;
		top: 115px;
		background: linear-gradient(rgba(128,239,73,.6),rgba(128,239,73,0));
		border-color: rgba(128,239,73,.8);
		transform: scale(.65);
		animation: up-down 1.7s infinite ease -0.3s;
	}
	ul li:nth-child(5) {
		left: 280px;
		top: -10px;
		background: linear-gradient(rgba(255,255,255,.5),rgba(255,255,255,0));
		border-color: rgba(255,255,255,.7);
		transform: scale(.6);
		animation: up-down 1.5s infinite;
	}
	ul li:nth-child(3) {
		left: 280px;
		top: 105px;
		background: linear-gradient(rgba(255,75,164,.5),rgba(255,75,164,0));
		border-color: rgba(255,75,164,.7);
		transform: scale(.75);
		animation: up-down 1.8s infinite;
	}
	ul li:nth-child(n+6) {
		display: none;
	}
	.mv-enter,.mv-leave-to {
		transform-origin: 200px 150px;
		transform: scale(.1);
		opacity: 0;
		transition: .5s
	}
	.mv-enter-active,.mv-leave-active {
		transition: .5s
	}
	@keyframes up-down {
		0% {margin-top: 0}
		50% {margin-top: 15px;opacity: .75;}
		100% {margin-top: 0;}
	}
</style>



// WEBPACK FOOTER //
// src/components/charts/MostPopularProducts.vue